import { render, staticRenderFns } from "./PropertyRoomShare.vue?vue&type=template&id=4bd81193&"
import script from "./PropertyRoomShare.vue?vue&type=script&lang=js&"
export * from "./PropertyRoomShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports